import React, { Component } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { injectIntl } from 'react-intl'
import messages from './messages'

class LanguageController extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.select = React.createRef()
  }

	setLanguage = eventKey => {
	  this.props.fn(eventKey)
	}

	getLanguageFullName = lang => {
	  switch (lang) {
	  case 'es':
	    return this.formatMessage(messages.espanol)
	  case 'eu':
	    return this.formatMessage(messages.euskera)
	  case 'en':
	    return this.formatMessage(messages.english)
	  default:
	  }
	}

	showLanguages = () => {
	  let buffer = []
	  const availableLanguages = ['es', 'eu', 'en']
	  let { selectedLanguage } = this.props

	  availableLanguages.forEach(lang => {
	    if (lang !== selectedLanguage) {
	      buffer.push(
	        <MenuItem key={lang} eventKey={lang} onSelect={this.setLanguage}>
	          {this.getLanguageFullName(lang)}
	        </MenuItem>
	      )
	    }
	  })
	  return buffer
	}

	render() {
	  return (
	    <DropdownButton
	      bsStyle={'primary'}
	      title={this.getLanguageFullName(this.props.selectedLanguage)}
	      id={'languages'}
	      data-toggle={'dropdown'}
	      noCaret
	      ref={this.dropdown}
	      value={this.props.selectedLanguage}
	    >
	      {this.showLanguages()}
	    </DropdownButton>
	  )
	}
}

export default injectIntl(LanguageController)



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageController/LanguageController.jsx